import { render, staticRenderFns } from "./TimeslotIssues.vue?vue&type=template&id=6f5c0f4c"
import script from "./TimeslotIssues.vue?vue&type=script&lang=js"
export * from "./TimeslotIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports